import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type ContentAnalysis } from '../../entity/api/content-analysis';
import { createBasicStoreState } from './basic-store';

type TModel = ContentAnalysis;

type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'articles-analysis' }
  )
);
